const skills = {
  'Programming Languages': ['C++','Python', 'JavaScript','CSS', 'HTML','SQL'],
  'Frameworks and Libraries': [
    'Bootstrap',
    'Express JS',
    'Mongo DB',
    'Node JS',
    'React JS',
    'Rest-API',
    'NumPy',
    'Pandas',
  ],
  'Cloud and Databases': [ 'AWS Lambda','AWS DynamoDB','AWS S3','MongoDB', 'MySQL'],
  'Tools, Editors, and IDEs': [
    'Git',
    'VS Code',
    'Jenkins',
    'Postman',
    'Terraform',
    'Github',
    'Android Studio'
    
  ],
  'Operating Systems': ['Windows'],
  Coursework: [
    'Data Structures',
    'Object-Oriented Programming',
    'Operating Systems',
    'Agile Software Methdologies',
    'Web Development',
    'Computer Networks',
    'Database Management Systems',
    'Machine Learning',
  ],
  'Soft Skills': [
    'Adaptability',
    'Communication',
    'Creativity',
    'Critical Thinking',
    'Leadership',
    'Problem Solving',
    'Teamwork',
    'Time Management'
  ],
  'Areas of Interest': [
    'Machine Learning',
    'GenAI',
    'Full Stack Development',
    'Cloud Computing',
    'Data Science'
  ]
}

export default skills
